import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Fragment } from 'react';
import { BONUS_NAMES } from "../../bonusesConstants.js";
import { getBonusesActiveList } from "../../bonusesSelectors.js";
import BonusGift50 from "./BonusGift50.jsx";
import BonusWelcome from "./BonusWelcome.jsx";
import { BinIcon } from "../../../../components/icon/Icon.jsx";
import {
    BonusActivePanelListContainerStyled,
    BonusActivePanelTitleStyled,
    BonusActivePanelWrapperStyled
} from "./styled/BonusActivePanelStyled.js";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext.js";

const BonusActivePanel = (props) => {
    const {bonusActiveList, flat} = props;
    const {getLangPath} = useLangContext();

    const getBonusComponent = (item) => {
        switch (item.name) {
            case BONUS_NAMES.WELCOME:
                return <BonusWelcome bonus={item} {...props}/>
            case BONUS_NAMES.GIFT50:
                return <BonusGift50 bonus={item} {...props}/>
            default:
                return null;
        }
    }

    return bonusActiveList.length > 0 && <BonusActivePanelWrapperStyled flat={flat}>
        {
            <BonusActivePanelTitleStyled flat={flat}>
                <BinIcon name="IcBonus" style={{fill: 'var(--color-secondary-active)'}}/>
                <span className="ms-1">{getLangPath('bonuses.activated_bonuses')}</span>
            </BonusActivePanelTitleStyled>
        }
        <BonusActivePanelListContainerStyled flat={flat}>
            {
                bonusActiveList.map(item => <Fragment key={item.name}>
                    {getBonusComponent(item)}
                </Fragment>)
            }
        </BonusActivePanelListContainerStyled>
    </BonusActivePanelWrapperStyled>
};

const mapStateToProps = createStructuredSelector({
    bonusActiveList: getBonusesActiveList,
})

export default connect(mapStateToProps)(BonusActivePanel);
